let language = {
    RETURNS_FILTER_NO: "Order No",
    RETURNS_FILTER_RETURN: "Return No",
    RETURNS_FILTER_STATUS: "Status",
    RETURNS_FILTER_RESET: "Reset",
    RETURNS_FILTER_SEARCH: "Search"
}

export { language }